import { HomepageHero } from 'components/Hero';
import React from 'react';

import { HeroSectionType } from '../../../utils/types';

export interface HeroContainerProps {
  content: HeroSectionType;
}

export const HeroContainer: React.FC<HeroContainerProps> = ({ content }) => {
  if (!content) {
    return null;
  }

  const {
    headline,
    description,
    backgroundColor,
    desktopImage,
    mobileImage,
    mainCta,
    secondaryCtaList,
    secondaryHeadline,
    listOfContentWithImages,
    topBanner,
  } = content;

  const formattedListOfContent = listOfContentWithImages?.map((item) => {
    return {
      heading: item.heading,
      image: item.image,
    };
  });

  const formattedTopBanner = {
    link: topBanner?.mainCta.url || '',
    text: topBanner?.headline || '',
    ctaText: topBanner?.mainCta.text || '',
  };

  return (
    <div>
      <HomepageHero
        headline={headline}
        description={description}
        mainCta={mainCta}
        desktopImage={desktopImage?.gatsbyImageData}
        mobileImage={mobileImage?.gatsbyImageData}
        secondaryCtaList={secondaryCtaList}
        secondaryHeadline={secondaryHeadline}
        listOfContent={formattedListOfContent}
        backgroundColor={backgroundColor}
        topBanner={formattedTopBanner}
      />
    </div>
  );
};

export default HeroContainer;
